import { useTranslation } from 'react-i18next';

import { ChevronRightIcon, SettingsIcon } from 'icons';
import { ListItemButton, ListItemIcon, ListItemText } from 'netline-ui';

const MobilePreferencesMenuItem = (props) => {
  const { t } = useTranslation();
  return (
    <ListItemButton {...props}>
      <ListItemIcon>
        <SettingsIcon />
      </ListItemIcon>
      <ListItemText>{t('mobileNavigation.preferences')}</ListItemText>
      <ListItemIcon>
        <ChevronRightIcon />
      </ListItemIcon>
    </ListItemButton>
  );
};

export default MobilePreferencesMenuItem;
